<template>
  <router-view />
</template>

<script>
export default {
  name: 'ServicesCompensatoryManagement',
};
</script>
